import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft, X } from 'lucide-react';
import { Button } from '../components/ui/button';

const CancelPage = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    // Remove URL parameters and navigate to home
    navigate('/', { replace: true });
  };
  return (
    <div className="min-h-screen bg-[var(--vp-paper)] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-md"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200, damping: 15 }}
          className="mb-6 flex justify-center"
        >
          <div className="w-20 h-20 bg-[var(--vp-sand)] rounded-full flex items-center justify-center">
            <XCircle className="w-10 h-10 text-[var(--vp-ink)]" />
          </div>
        </motion.div>
        
        <h1 className="text-3xl font-semibold text-[var(--vp-ink)] mb-4">
          Platba zrušena
        </h1>
        
        <p className="text-[var(--vp-ink)]/70 mb-8">
          Vaše platba byla zrušena. Nebyli jste účtováni.
          Pokud chcete, můžete se vrátit a zkusit to znovu.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/#pricing">
            <Button 
              className="btn-accent px-6 py-3 w-full sm:w-auto"
              data-testid="cancel-retry-button"
            >
              Zkusit znovu
            </Button>
          </Link>
          
          <Link to="/">
            <Button 
              variant="outline" 
              className="px-6 py-3 w-full sm:w-auto border-[var(--vp-line)]"
              data-testid="cancel-back-button"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zpět na hlavní stránku
            </Button>
          </Link>

          <Button 
            onClick={handleClose}
            variant="outline"
            className="px-6 py-3 w-full sm:w-auto border-[var(--vp-line)]"
            data-testid="cancel-close-button"
          >
            <X className="w-4 h-4 mr-2" />
            Zavřít
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default CancelPage;
